/**
 * Quotes: one candidate vendor's price for one need (an expense line still
 * being sourced). A vendor keeps one quote per need; a revised price updates
 * it and the earlier figures are kept as a revision.
 */
export var QuoteStatus;
(function (QuoteStatus) {
    /** Asked for; nothing back yet. */
    QuoteStatus["REQUESTED"] = "REQUESTED";
    /** Figures are in. */
    QuoteStatus["RECEIVED"] = "RECEIVED";
    /** The chosen one — the need is booked with this vendor and price. */
    QuoteStatus["ACCEPTED"] = "ACCEPTED";
    QuoteStatus["DECLINED"] = "DECLINED";
    /** The vendor dropped out. */
    QuoteStatus["WITHDRAWN"] = "WITHDRAWN";
})(QuoteStatus || (QuoteStatus = {}));
/** A quote that can still be accepted, declined or revised. */
export const OPEN_QUOTE_STATUSES = [
    QuoteStatus.REQUESTED,
    QuoteStatus.RECEIVED,
];
//# sourceMappingURL=quote.js.map